import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={hover ? {
        y: -4,
        boxShadow: "0 20px 40px -12px rgba(0, 0, 0, 0.15)",
        scale: 1.01,
        transition: { duration: 0.3, ease: "easeOut" }
      } : {}}
      transition={{
        opacity: { duration: 0.4 },
        y: { duration: 0.4, ease: "easeOut" }
      }}
      className={`card ${className}`}
    >
      {children}
    </motion.div>
  );
};